import { Paper, Skeleton, Typography } from '@mui/material';
import { formatNumber } from '@vy/utils';
import classNames from 'classnames';
import React from 'react';
import { ApprovedFilledIcon } from '../../../components/icons/ApprovedFilledIcon';

type InvoicePreviewProps = {
  title: string;
  value: number;
  overcharges?: number;
  selected: boolean;
  onClick: () => void;
  approved?: boolean;
  loading?: boolean;
};

export const InvoicePreview: React.FC<InvoicePreviewProps> = ({
  title,
  value,
  overcharges,
  selected,
  onClick,
  approved,
  loading = false,
}) => {
  if (loading) {
    return <Skeleton variant="rounded" height={60} className="rounded-2lg" />;
  }

  return (
    <Paper
      elevation={0}
      sx={(theme) => ({
        border: '1px solid',
        borderColor: theme.palette.divider,
        borderRadius: '8px',
      })}
      onClick={onClick}
      className={classNames(
        'px-8 py-4 rounded-2lg cursor-pointer',
        { 'bg-selected font-semibold': selected },
        { 'bg-white': !selected },
        { relative: approved },
      )}
    >
      {approved && (
        <div className="bg-btn-gradient-green absolute left-0 top-1/2 h-10 w-1 -translate-x-1/2 -translate-y-1/2 rounded" />
      )}
      <Typography className="flex items-center justify-between gap-4">
        <Typography variant="body1" sx={{
          fontWeight: 400
        }}>
          {title}
        </Typography>
        <Typography variant="body1">{value}</Typography>
      </Typography>
      {overcharges ? (
        <Typography
          className={classNames(
            'mt-3 flex items-center gap-2 flex-wrap w-fit justify-center rounded-2lg bg-error-light px-2 py-1 uppercase text-error-secondary text-sm',
            { 'border-error-secondary border-[0.5px]': selected },
          )}
        >
          <Typography variant="body2" sx={{
            fontWeight: 600
          }}>
            {`$${formatNumber(overcharges)}`}
          </Typography>
          <Typography variant="body2" sx={{
            fontWeight: 600
          }}>
            Overages
          </Typography>
        </Typography>
      ) : (
        <></>
      )}
      {approved && (
        <div className="absolute -right-5 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <ApprovedFilledIcon />
        </div>
      )}
    </Paper>
  );
};
